import { css } from "@emotion/core";

import { color, fontSizes, fonts } from "../../../theme/Theme";

export const modalStyles = css({
  ".ant-modal-header": {
    backgroundColor: color.modalRed,
    ".ant-modal-title": {
      fontSize: fontSizes.cardLabel,
      color: color.white,
      fontFamily: fonts.bold
    }
  },
  ".reject-modal-label": {
    fontSize: fontSizes.cardLabel,
    fontFamily: fonts.bold
  },
  ".ant-modal-footer": {
    border: "none"
  }
});

export const acceptRejectFoldRadioStyle = css({
  ".ant-radio-group": {
    flexDirection: "column"
  },
  ".ant-radio-wrapper": {
    paddingBottom: "1rem",
    display: "flex",
    alignItems: "center"
  }
});
